import clsx from 'clsx'

import DocumentationSidebarTreeLink from './DocumentationSidebarTreeLink'
import {trlObject} from '~/services/intl'

import type {TopicItem} from './DocumentationSidebar'

type Props = {
    item: TopicItem
    level?: number
}

export default function DocumentationSidebarTreeFolder({item, level = 0}: Props) {
    const {items} = item

    return <>
        {item.name &&
            <div className={clsx(
                'documentation-menu__item',
                level > 0
                    ? 'documentation-menu__item_subsection'
                    : 'documentation-menu__item_section'
            )}>
                {item.name}
            </div>
        }
        {item.path &&
            <div className='documentation-menu__item documentation-menu__item_folder'>
                {trlObject('documentation')[item.path]}
            </div>
        }
        {items?.map((subitem, index) => subitem.items
            ? <DocumentationSidebarTreeFolder
                key={index}
                item={subitem}
                level={level + 1}
            />
            : <DocumentationSidebarTreeLink
                key={index}
                path={subitem.isDynamicPage
                    ? `${subitem.root}/${subitem.path}`
                    : `${subitem.root || item.path}-${subitem.path}`
                }
                item={subitem}
            />
        )}
    </>
}
